var tokenKey = 'id_token';
export var getTokenFromSession = function () {
    var token = sessionStorage.getItem(tokenKey) || '';
    return token;
};
